"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Mutation = Mutation;
exports.Query = Query;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _client = require("@apollo/client");

function Mutation(props) {
  const [runMutation, result] = (0, _client.useMutation)(props.mutation, props);
  return props.children ? props.children(runMutation, result) : null;
}

function Query(props) {
  const {
    children,
    query
  } = props,
        options = (0, _objectWithoutPropertiesLoose2.default)(props, ["children", "query"]);
  const result = (0, _client.useQuery)(query, options);
  return children && result ? children(result) : null;
}